import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import {
  PaymentListType,
  PaymentDetailType,
  PaginationCursorType,
} from '../@types/paymentDashboard'

const { Get, Post } = axiosInstanceApiGateway

export type GetPaymentListResponseType = {
  data: {
    payment_list: PaymentListType[]
    pagination_response: PaginationCursorType
  }
}
export type GetPaymentListRequestType = {
  params: {
    order_id?: number
    payment_method?: string
    payment_status?: string
    start_date?: string
    end_date?: string
    page?: number
    limit?: number
    cursor?: string
  }
}

export const getPaymentList = ({ params }: GetPaymentListRequestType) =>
  Get<GetPaymentListResponseType, true>({
    url: '/payment/internal/v1/dashboard/list',
    params,
  })

export type GetPaymentDetailRequestType = {
  id: string
}

export type GetPaymentDetailResponseType = {
  data: PaymentDetailType
}

export const getPaymentDetail = ({ id }: GetPaymentDetailRequestType) =>
  Get<GetPaymentDetailResponseType, true>({
    url: `/payment/internal/v1/dashboard/${id}`,
  })

export type PostReversePaymentRequestType = {
  id: string
}
export type PostReversePaymentResponseType = {
  data: {
    success: boolean
  }
}

export const postReversePayment = ({ id }: PostReversePaymentRequestType) =>
  Post<PostReversePaymentResponseType, true>({
    url: `/payment/internal/v1/${id}/reverse`,
  })
